(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sb-smooche-1-million"]) return;
  try {
    
  /**
   * Autoplay layer over a native scroll container.
   *
   * The markup renders the photo list twice. Each frame the element nudges
   * scrollLeft forward; once it passes the width of the first copy it subtracts
   * that width, which lands on a visually identical position and makes the loop
   * seamless. Because the movement is scrollLeft and not a transform, dragging,
   * flicking and keyboard scrolling keep working untouched.
   *
   * Autoplay yields to the visitor: it pauses on pointer down (an active drag
   * or touch scroll) and while anything inside has keyboard focus, but not on
   * hover, per client feedback (03/09/2026) that the strip should keep moving
   * while the visitor's mouse sits over it. It never runs at all for a
   * visitor who asked for reduced motion.
   */
  if (!customElements.get('smooche-hm-carousel')) {
    customElements.define(
      'smooche-hm-carousel',
      class SmoocheHmCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.smooche-hm__reviews-track');
          this.firstList = this.querySelector('.smooche-hm__reviews-list');
          if (!this.track || !this.firstList) return;

          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.wantsAutoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
          this.speed = parseFloat(this.dataset.speed) || 40;
          this.paused = false;
          this.lastFrame = null;

          this.onPause = () => { this.paused = true; };
          this.onResume = () => { this.paused = false; };

          // No pointerenter/pointerleave: hovering the strip no longer pauses
          // it, per client feedback (03/09/2026). pointerdown still pauses,
          // so an active drag or touch scroll is not fighting the autoplay,
          // and focus still pauses for keyboard users tabbing through the
          // photos.
          this.addEventListener('pointerdown', this.onPause);
          this.addEventListener('focusin', this.onPause);
          this.addEventListener('focusout', this.onResume);
          window.addEventListener('pointerup', this.onResume);

          if (this.wantsAutoplay) this.start();
        }

        disconnectedCallback() {
          this.stop();
          this.removeEventListener('pointerdown', this.onPause);
          this.removeEventListener('focusin', this.onPause);
          this.removeEventListener('focusout', this.onResume);
          window.removeEventListener('pointerup', this.onResume);
        }

        start() {
          const step = (now) => {
            if (this.lastFrame === null) this.lastFrame = now;
            const delta = (now - this.lastFrame) / 1000;
            this.lastFrame = now;

            if (!this.paused) {
              const loopWidth = this.firstList.scrollWidth;
              this.track.scrollLeft += this.speed * delta;
              if (loopWidth > 0 && this.track.scrollLeft >= loopWidth) {
                this.track.scrollLeft -= loopWidth;
              }
            }

            this.frame = requestAnimationFrame(step);
          };

          this.frame = requestAnimationFrame(step);
        }

        stop() {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = null;
          this.lastFrame = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-smooche-advertorial"]) return;
  try {
    
  // Rolling countdown for the announcement bar. Counts down from N minutes and
  // restarts when it hits zero, so the bar is never frozen at 00:00:00 for a
  // visitor who lands days after the section was configured.
  //
  // The deadline is kept in sessionStorage keyed by the section id, so the
  // number does not jump back to the full duration on every page view inside
  // one visit. A fresh session starts a fresh countdown.
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function startCountdown(el) {
      if (el.dataset.advCountdownBound === 'true') return;
      el.dataset.advCountdownBound = 'true';

      var minutes = parseInt(el.dataset.minutes, 10);
      if (!minutes || minutes < 1) minutes = 125;
      var durationMs = minutes * 60 * 1000;

      var root = el.closest('[data-sb-advertorial]');
      var storageKey = 'sb-adv-countdown-' + (root ? root.className : 'default');
      var deadline = null;

      try {
        var stored = window.sessionStorage.getItem(storageKey);
        if (stored) deadline = parseInt(stored, 10);
      } catch (e) {
        // Private mode or blocked storage. Fall through to a fresh deadline.
      }

      if (!deadline || isNaN(deadline) || deadline <= Date.now()) {
        deadline = Date.now() + durationMs;
        try {
          window.sessionStorage.setItem(storageKey, String(deadline));
        } catch (e) {
          // Non fatal: the countdown still runs, it just restarts per page view.
        }
      }

      var slots = {
        hours: el.querySelector('[data-unit="hours"]'),
        minutes: el.querySelector('[data-unit="minutes"]'),
        seconds: el.querySelector('[data-unit="seconds"]')
      };

      function tick() {
        var remaining = deadline - Date.now();

        if (remaining <= 0) {
          deadline = Date.now() + durationMs;
          try {
            window.sessionStorage.setItem(storageKey, String(deadline));
          } catch (e) {
            // Ignore.
          }
          remaining = durationMs;
        }

        var totalSeconds = Math.floor(remaining / 1000);
        var h = Math.floor(totalSeconds / 3600);
        var m = Math.floor((totalSeconds % 3600) / 60);
        var sec = totalSeconds % 60;

        if (slots.hours) slots.hours.textContent = pad(h);
        if (slots.minutes) slots.minutes.textContent = pad(m);
        if (slots.seconds) slots.seconds.textContent = pad(sec);
      }

      tick();
      window.setInterval(tick, 1000);
    }

    function init(scope) {
      var nodes = (scope || document).querySelectorAll('[data-adv-countdown]');
      for (var i = 0; i < nodes.length; i++) startCountdown(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    // Theme editor: a re-rendered section arrives with fresh, unbound markup.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-smooche-glp1-listicle"]) return;
  try {
    
  if (!customElements.get('sb-glp1-countdown')) {
    class SbGlp1Countdown extends HTMLElement {
      connectedCallback() {
        const durationMinutes = Number.parseInt(this.dataset.durationMinutes, 10);
        const safeDuration = Number.isFinite(durationMinutes) && durationMinutes > 0 ? durationMinutes : 125;

        this.endsAt = Date.now() + safeDuration * 60 * 1000;
        this.hoursSlot = this.querySelector('[data-countdown-hours]');
        this.minutesSlot = this.querySelector('[data-countdown-minutes]');
        this.secondsSlot = this.querySelector('[data-countdown-seconds]');

        this.update();
        this.timer = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      update() {
        const remaining = Math.max(0, this.endsAt - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (this.hoursSlot) this.hoursSlot.textContent = String(hours).padStart(2, '0');
        if (this.minutesSlot) this.minutesSlot.textContent = String(minutes).padStart(2, '0');
        if (this.secondsSlot) this.secondsSlot.textContent = String(seconds).padStart(2, '0');

        if (remaining === 0) window.clearInterval(this.timer);
      }
    }

    customElements.define('sb-glp1-countdown', SbGlp1Countdown);
  }

  /**
   * Sticky CTA visibility.
   *
   * Two facts decide it: the reader has scrolled past the marker that follows
   * reason N, and the element the button points at is not on screen yet. The
   * bar shows only when the first is true and the second is false, so it steps
   * out of the way instead of covering its own destination.
   *
   * Both are measured with getBoundingClientRect on scroll, not with an
   * IntersectionObserver. The marker has no height, and a zero-area target
   * never crosses an observer threshold, so an observer reports the position
   * the marker had at load and then goes quiet for the rest of the page
   * (verified in Chrome: the callback fires once and never again). Reads are
   * coalesced into one animation frame, so a fast scroll still costs a single
   * measurement per frame.
   */
  if (!customElements.get('sb-glp1-sticky-cta')) {
    class SbGlp1StickyCta extends HTMLElement {
      connectedCallback() {
        this.trigger = this.pick(this.dataset.triggerSelector);
        this.stop = this.pick(this.dataset.stopSelector);
        this.frame = 0;
        this.onScroll = () => this.schedule();

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        // The destination lives in a later section and can be rendered by an
        // app block after this element upgrades, so look for it again once the
        // page has settled.
        if (!this.stop && this.dataset.stopSelector) {
          window.addEventListener(
            'load',
            () => {
              this.stop = this.pick(this.dataset.stopSelector);
              this.read();
            },
            { once: true }
          );
        }

        this.read();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) window.cancelAnimationFrame(this.frame);
      }

      pick(selector) {
        if (!selector) return null;

        try {
          return document.querySelector(selector);
        } catch (error) {
          return null;
        }
      }

      schedule() {
        if (this.frame) return;

        this.frame = window.requestAnimationFrame(() => {
          this.frame = 0;
          this.read();
        });
      }

      read() {
        // No marker means nothing to wait for, so show the bar straight away
        // rather than leaving one the merchant switched on hidden forever.
        const passed = this.trigger ? this.trigger.getBoundingClientRect().top < 0 : true;
        let reached = false;

        if (this.stop) {
          const box = this.stop.getBoundingClientRect();
          reached = box.top < window.innerHeight && box.bottom > 0;
        }

        this.dataset.visible = passed && !reached ? 'true' : 'false';
      }
    }

    customElements.define('sb-glp1-sticky-cta', SbGlp1StickyCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-smooche-happy-mammoth"]) return;
  try {
    
  /**
   * Autoplay layer over a native scroll container.
   *
   * The markup renders the photo list twice. Each frame the element nudges
   * scrollLeft forward; once it passes the width of the first copy it subtracts
   * that width, which lands on a visually identical position and makes the loop
   * seamless. Because the movement is scrollLeft and not a transform, dragging,
   * flicking and keyboard scrolling keep working untouched.
   *
   * Autoplay yields to the visitor: it pauses on pointer down (an active drag
   * or touch scroll) and while anything inside has keyboard focus, but not on
   * hover, per client feedback (03/09/2026) that the strip should keep moving
   * while the visitor's mouse sits over it. It never runs at all for a
   * visitor who asked for reduced motion.
   */
  if (!customElements.get('smooche-hm-carousel')) {
    customElements.define(
      'smooche-hm-carousel',
      class SmoocheHmCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.smooche-hm__reviews-track');
          this.firstList = this.querySelector('.smooche-hm__reviews-list');
          if (!this.track || !this.firstList) return;

          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.wantsAutoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
          this.speed = parseFloat(this.dataset.speed) || 40;
          this.paused = false;
          this.lastFrame = null;

          this.onPause = () => { this.paused = true; };
          this.onResume = () => { this.paused = false; };

          // No pointerenter/pointerleave: hovering the strip no longer pauses
          // it, per client feedback (03/09/2026). pointerdown still pauses,
          // so an active drag or touch scroll is not fighting the autoplay,
          // and focus still pauses for keyboard users tabbing through the
          // photos.
          this.addEventListener('pointerdown', this.onPause);
          this.addEventListener('focusin', this.onPause);
          this.addEventListener('focusout', this.onResume);
          window.addEventListener('pointerup', this.onResume);

          if (this.wantsAutoplay) this.start();
        }

        disconnectedCallback() {
          this.stop();
          this.removeEventListener('pointerdown', this.onPause);
          this.removeEventListener('focusin', this.onPause);
          this.removeEventListener('focusout', this.onResume);
          window.removeEventListener('pointerup', this.onResume);
        }

        start() {
          const step = (now) => {
            if (this.lastFrame === null) this.lastFrame = now;
            const delta = (now - this.lastFrame) / 1000;
            this.lastFrame = now;

            if (!this.paused) {
              const loopWidth = this.firstList.scrollWidth;
              this.track.scrollLeft += this.speed * delta;
              if (loopWidth > 0 && this.track.scrollLeft >= loopWidth) {
                this.track.scrollLeft -= loopWidth;
              }
            }

            this.frame = requestAnimationFrame(step);
          };

          this.frame = requestAnimationFrame(step);
        }

        stop() {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = null;
          this.lastFrame = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-smooche-howto"]) return;
  try {
    
  (function () {
    'use strict';

    // Must match the radius used in snippets/sb-smooche-howto-ring.liquid.
    var CIRCUMFERENCE = 327;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function track(root, name, payload) {
      if (root.getAttribute('data-track') !== 'true') return;
      var detail = payload || {};
      detail.section = root.getAttribute('data-sb-howto');

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, detail));
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    }

    function SmoocheHowTo(root) {
      this.root = root;
      this.radios = Array.prototype.slice.call(root.querySelectorAll('[data-sb-radio]'));
      this.rings = Array.prototype.slice.call(root.querySelectorAll('[data-sb-stat]'));
      this.videos = Array.prototype.slice.call(root.querySelectorAll('[data-sb-video]'));
      this.carousels = Array.prototype.slice.call(root.querySelectorAll('[data-sb-carousel]'));
      this.scrollMarks = [25, 50, 75, 100];
      this.init();
    }

    SmoocheHowTo.prototype.init = function () {
      this.bindChooser();
      this.bindDeepLink();
      this.bindRings();
      this.bindCarousels();
      this.bindTimelines();
      this.bindVideos();
      this.syncVideos();
      this.bindScrollDepth();
    };

    // 1. Chooser ----------------------------------------------------------

    SmoocheHowTo.prototype.activeGuide = function () {
      for (var i = 0; i < this.radios.length; i++) {
        if (this.radios[i].checked) return this.radios[i].getAttribute('data-guide');
      }
      return null;
    };

    SmoocheHowTo.prototype.bindChooser = function () {
      var self = this;

      this.radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          var guide = radio.getAttribute('data-guide');

          // Keep the URL shareable without scrolling the page.
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', '#' + guide);
          }

          self.resetRings();
          self.syncCarousels();
          self.syncVideos();
          window.requestAnimationFrame(function () {
            self.syncTimelines();
          });
          track(self.root, 'sb_howto_guide_open', { guide: guide });
        });
      });
    };

    // 2. Deep link --------------------------------------------------------

    SmoocheHowTo.prototype.selectGuide = function (key, scroll) {
      if (!key) return false;
      var wanted = String(key).toLowerCase();

      for (var i = 0; i < this.radios.length; i++) {
        if (this.radios[i].getAttribute('data-guide') !== wanted) continue;
        if (!this.radios[i].checked) {
          this.radios[i].checked = true;
          this.radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (scroll) {
          var chooser = this.root.querySelector('.sb-howto__chooser');
          if (chooser && chooser.scrollIntoView) {
            chooser.scrollIntoView({
              behavior: prefersReducedMotion() ? 'auto' : 'smooth',
              block: 'start'
            });
          }
        }
        return true;
      }
      return false;
    };

    SmoocheHowTo.prototype.keyFromUrl = function () {
      var hash = (window.location.hash || '').replace('#', '');
      if (hash) return hash;
      try {
        return new URLSearchParams(window.location.search).get('guide') || '';
      } catch (e) {
        return '';
      }
    };

    SmoocheHowTo.prototype.bindDeepLink = function () {
      var self = this;

      // A panel that is not selected is display:none, so the browser cannot jump
      // to its anchor on its own. Switch first, then scroll.
      this.selectGuide(this.keyFromUrl(), true);

      window.addEventListener('hashchange', function () {
        self.selectGuide(self.keyFromUrl(), true);
      });
    };

    // 3. Rings ------------------------------------------------------------

    SmoocheHowTo.prototype.fillRing = function (ring) {
      var bar = ring.querySelector('.sb-howto__stat-fill');
      if (bar) {
        bar.style.width = ring.getAttribute('data-pct') + '%';
        return;
      }
      var circle = ring.querySelector('.sb-howto__ring-value');
      if (!circle) return;
      circle.style.strokeDashoffset = ring.getAttribute('data-offset');
    };

    SmoocheHowTo.prototype.emptyRing = function (ring) {
      var bar = ring.querySelector('.sb-howto__stat-fill');
      if (bar) {
        bar.style.width = '0%';
        return;
      }
      var circle = ring.querySelector('.sb-howto__ring-value');
      if (!circle) return;
      circle.style.strokeDashoffset = CIRCUMFERENCE;
    };

    SmoocheHowTo.prototype.bindRings = function () {
      var self = this;

      // Without IntersectionObserver, or with reduced motion on, the rings keep
      // the value Liquid already rendered. Nothing to do.
      if (!('IntersectionObserver' in window) || prefersReducedMotion()) return;

      this.rings.forEach(function (ring) {
        self.emptyRing(ring);
      });

      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            self.fillRing(entry.target);
            self.observer.unobserve(entry.target);
          });
        },
        { threshold: 0.35 }
      );

      this.rings.forEach(function (ring) {
        self.observer.observe(ring);
      });
    };

    // Switching guide reveals rings that were never observed while hidden.
    SmoocheHowTo.prototype.resetRings = function () {
      var self = this;
      if (!this.observer) return;

      window.requestAnimationFrame(function () {
        self.rings.forEach(function (ring) {
          if (!ring.offsetParent) return;
          if (ring.getAttribute('data-done') === 'true') return;
          ring.setAttribute('data-done', 'true');
          self.fillRing(ring);
        });
      });
    };

    // 3b. Ingredient carousel ---------------------------------------------

    SmoocheHowTo.prototype.bindCarousels = function () {
      var self = this;

      this.carousels.forEach(function (carousel) {
        var track = carousel.querySelector('[data-sb-track]');
        var prev = carousel.querySelector('[data-sb-prev]');
        var next = carousel.querySelector('[data-sb-next]');
        var dotsWrap = carousel.querySelector('[data-sb-dots]');
        if (!track) return;

        var cards = Array.prototype.slice.call(track.children);
        if (!cards.length) return;

        function step() {
          var first = cards[0].getBoundingClientRect().width;
          var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          return first + gap;
        }

        function index() {
          var size = step();
          if (!size) return 0;
          return Math.round(track.scrollLeft / size);
        }

        // Build one dot per card.
        var dots = [];
        if (dotsWrap) {
          cards.forEach(function (card, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'sb-howto__dot';
            dot.setAttribute('aria-label', String(i + 1));
            dot.addEventListener('click', function () {
              track.scrollTo({ left: step() * i, behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
            dots.push(dot);
          });
        }

        function sync() {
          var scrollable = track.scrollWidth - track.clientWidth > 1;
          carousel.setAttribute('data-scrollable', scrollable ? 'true' : 'false');

          var i = index();
          dots.forEach(function (dot, n) {
            dot.setAttribute('aria-current', n === i ? 'true' : 'false');
          });
        }

        // The arrows wrap: past the last card you land on the first, and back
        // from the first you land on the last. Neither arrow is ever disabled,
        // which is why sync no longer touches them.
        function move(direction) {
          var max = track.scrollWidth - track.clientWidth;
          if (max <= 1) return;

          if (direction > 0 && track.scrollLeft >= max - 1) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }
          if (direction < 0 && track.scrollLeft <= 1) {
            track.scrollTo({ left: max, behavior: 'smooth' });
            return;
          }
          track.scrollBy({ left: step() * direction, behavior: 'smooth' });
        }

        if (prev) prev.addEventListener('click', function () { move(-1); });
        if (next) next.addEventListener('click', function () { move(1); });

        var ticking = false;
        track.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
              ticking = false;
              sync();
            });
          },
          { passive: true }
        );

        window.addEventListener('resize', sync);
        carousel.syncCarousel = sync;
        sync();
      });
    };

    // 3c. What to expect timeline ------------------------------------------

    // The fill reaches a stage when its dot crosses this line, measured from the
    // top of the viewport. The same line drives the fill and the dot, so the
    // tick lands the moment the pink arrives.
    var TIMELINE_LINE = 0.7;

    SmoocheHowTo.prototype.bindTimelines = function () {
      var self = this;
      this.timelines = Array.prototype.slice.call(this.root.querySelectorAll('[data-sb-timeline]'));
      if (!this.timelines.length) return;

      // Reduced motion keeps the finished state Liquid rendered: full rail,
      // every dot ticked, every card in place. The rail is still measured.
      this.timelineMotion = !prefersReducedMotion();
      if (this.timelineMotion) {
        this.timelines.forEach(function (timeline) {
          timeline.setAttribute('data-armed', '');
        });
      }

      var ticking = false;
      function schedule() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          self.syncTimelines();
        });
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      window.addEventListener('load', schedule);
      this.syncTimelines();
    };

    SmoocheHowTo.prototype.syncTimelines = function () {
      if (!this.timelines) return;
      var motion = this.timelineMotion;
      var line = window.innerHeight * TIMELINE_LINE;

      this.timelines.forEach(function (timeline) {
        // A closed guide is display:none and measures zero. Skip it; switching
        // guide calls this again once the panel is visible.
        if (timeline.offsetParent === null) return;

        var trackEl = timeline.querySelector('.sb-howto__tl-track');
        var rail = timeline.querySelector('[data-sb-tl-rail]');
        var fill = timeline.querySelector('[data-sb-tl-fill]');
        var items = timeline.querySelectorAll('[data-sb-tl-item]');
        var dots = timeline.querySelectorAll('[data-sb-tl-dot]');
        if (!trackEl || !rail || !dots.length) return;

        var top = trackEl.getBoundingClientRect().top;
        var centres = [];
        for (var i = 0; i < dots.length; i++) {
          var box = dots[i].getBoundingClientRect();
          centres.push(box.top + box.height / 2);
        }

        // The rail runs from the first dot's centre to the last one's.
        var first = centres[0];
        var length = Math.max(centres[centres.length - 1] - first, 0);
        rail.style.top = first - top + 'px';
        rail.style.bottom = 'auto';
        rail.style.height = length + 'px';

        if (!motion) return;

        if (fill) fill.style.height = Math.min(Math.max(line - first, 0), length) + 'px';

        for (var n = 0; n < items.length; n++) {
          items[n].classList.toggle('is-on', centres[n] <= line + 0.5);
        }
      });
    };

    SmoocheHowTo.prototype.syncVideos = function () {
      var self = this;
      if (prefersReducedMotion()) return;

      window.requestAnimationFrame(function () {
        self.videos.forEach(function (video) {
          if (!video.hasAttribute('data-sb-gif')) return;
          if (video.offsetParent === null) {
            video.pause();
            return;
          }
          var started = video.play();
          if (started && started.catch) {
            started.catch(function () {});
          }
        });
      });
    };

    // A panel that was display:none measured zero, so re-measure on reveal.
    SmoocheHowTo.prototype.syncCarousels = function () {
      var self = this;
      window.requestAnimationFrame(function () {
        self.carousels.forEach(function (carousel) {
          if (typeof carousel.syncCarousel === 'function') carousel.syncCarousel();
        });
      });
    };

    // 4. Video ------------------------------------------------------------

    SmoocheHowTo.prototype.bindVideos = function () {
      var self = this;

      this.videos.forEach(function (video) {
        var guide = video.getAttribute('data-guide');
        var isGif = video.hasAttribute('data-sb-gif');
        var wrap = video.parentNode;
        var play = wrap ? wrap.querySelector('[data-sb-play]') : null;
        var seen = {};

        // The poster stays on top until a frame is really painted, so a clip
        // that is still loading never shows as a black block.
        video.addEventListener('playing', function () {
          if (wrap) wrap.setAttribute('data-playing', 'true');
          if (play) play.hidden = true;
        });

        if (play) {
          play.hidden = false;
          play.addEventListener('click', function () {
            if (!isGif) video.controls = true;
            var started = video.play();
            if (started && started.catch) {
              started.catch(function () {
                play.hidden = false;
              });
            }
          });
        }

        if (isGif) {
          // Motion that starts on its own is a preference, not a default.
          if (prefersReducedMotion()) {
            video.removeAttribute('autoplay');
            video.controls = true;
            video.pause();
            return;
          }

          // A video inside a closed guide is display:none but would still be
          // fetched and decoded, so play only what is on screen and open.
          if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (entry.isIntersecting && entry.target.offsetParent !== null) {
                    var started = entry.target.play();
                    if (started && started.catch) {
                      started.catch(function () {});
                    }
                  } else {
                    entry.target.pause();
                  }
                });
              },
              { threshold: 0.25 }
            );
            io.observe(video);
          }

          // A play here is the page starting itself, not a viewer choosing to
          // watch, so play and watch depth are not tracked in this mode.
          return;
        }

        // Click mode: the overlay replaces native controls until first play.
        if (play) video.removeAttribute('controls');

        video.addEventListener('play', function () {
          track(self.root, 'sb_howto_video_play', { guide: guide });
        });

        video.addEventListener('timeupdate', function () {
          if (!video.duration || !isFinite(video.duration)) return;
          var pct = Math.floor((video.currentTime / video.duration) * 100);

          [25, 50, 75, 95].forEach(function (mark) {
            if (pct < mark || seen[mark]) return;
            seen[mark] = true;
            track(self.root, 'sb_howto_video_progress', {
              guide: guide,
              percent: mark === 95 ? 100 : mark
            });
          });
        });

        video.addEventListener('ended', function () {
          video.controls = false;
          video.load();
          if (wrap) wrap.removeAttribute('data-playing');
          if (play) play.hidden = false;
        });
      });
    };

    // 5. Scroll depth -----------------------------------------------------

    SmoocheHowTo.prototype.bindScrollDepth = function () {
      var self = this;
      var seen = {};
      var ticking = false;

      function measure() {
        ticking = false;
        var box = self.root.getBoundingClientRect();
        var total = box.height - window.innerHeight;
        if (total <= 0) return;

        var pct = Math.round((-box.top / total) * 100);
        if (pct < 0) return;

        self.scrollMarks.forEach(function (mark) {
          if (pct < mark || seen[mark]) return;
          seen[mark] = true;
          track(self.root, 'sb_howto_scroll_depth', { percent: mark });
        });
      }

      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(measure);
        },
        { passive: true }
      );
    };

    // Boot ----------------------------------------------------------------

    function boot(scope) {
      var roots = (scope || document).querySelectorAll('[data-sb-howto]');
      Array.prototype.forEach.call(roots, function (root) {
        if (root.hasAttribute('data-sb-ready')) return;
        root.setAttribute('data-sb-ready', 'true');
        new SmoocheHowTo(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot(document);
      });
    } else {
      boot(document);
    }

    // Theme editor re-renders the section without a page load.
    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
